import {Badge} from "@mantine/core"
import {
    ApplicationProduct,
    ApplicationProductStatus
} from "../types.ts";

export const ApplicationProductStatusBadge = ({record}: { record: ApplicationProduct }) => {

    if (record.applicationProductStatus === ApplicationProductStatus.ACTIVE) {
        return <Badge color={'green'}>Active</Badge>;
    } else if (record.applicationProductStatus === ApplicationProductStatus.INACTIVE) {
        return <Badge color={'red'}>Inactive</Badge>
    }
}